<template>
  <div class="privacy-policy" dir="rtl">
    <div class="container">
      <h1>מדיניות פרטיות</h1>
      
      <div class="section">
        <h2>מבוא</h2>
        <p>מדיניות פרטיות זו מסבירה בפירוט כיצד אנו אוספים, משתמשים, מעבדים, משתפים ומגנים על המידע האישי שלך בעת השימוש באתר שלנו. אנו מחויבים לשקיפות מלאה ולהגנה על פרטיותך.</p>
        <p><strong>עדכון אחרון:</strong> 03.01.2026</p>
      </div>

      <div class="section">
        <h2>1. איזה נתונים אישיים אנו אוספים</h2>
        <p>אנו אוספים את סוגי המידע הבאים:</p>
        
        <h3>מידע שאתה מספק באופן פעיל:</h3>
        <ul>
          <li><strong>פרטי יצירת קשר:</strong> שם מלא, מספר טלפון, כתובת דוא"ל</li>
          <li><strong>פרטי אירוע:</strong> תאריך האירוע, סוג השירות המבוקש</li>
          <li><strong>הערות והעדפות:</strong> הערות נוספות שאתה משתף בטופס יצירת הקשר</li>
          <li><strong>העדפות תקשורת:</strong> בחירה בין דוא"ל או WhatsApp</li>
        </ul>

        <h3>מידע טכני שנאסף באופן אוטומטי:</h3>
        <ul>
          <li><strong>כתובת IP:</strong> כתובת האינטרנט של המכשיר שלך</li>
          <li><strong>מידע על הדפדפן:</strong> סוג דפדפן, גרסה, שפה מועדפת</li>
          <li><strong>מידע על המכשיר:</strong> סוג מכשיר, מערכת הפעלה, רזולוציית מסך</li>
          <li><strong>נתוני גלישה:</strong> דפים שביקרת, זמן ביקור, משך שהייה בכל דף</li>
          <li><strong>מקור הגעה:</strong> מאיזה אתר או מנוע חיפוש הגעת אלינו</li>
          <li><strong>מיקום גיאוגרפי כללי:</strong> מדינה ועיר (לא מיקום מדויק)</li>
        </ul>

        <h3>עוגיות (Cookies) ומעקב:</h3>
        <ul>
          <li><strong>עוגיות הכרחיות:</strong> לתפקוד בסיסי של האתר</li>
          <li><strong>עוגיות אנליטיות:</strong> Google Analytics לניתוח שימוש באתר</li>
          <li><strong>עוגיות שיווק:</strong> Google Tag Manager</li>
          <li><strong>עוגיות העדפות:</strong> שמירת בחירות שלך באתר</li>
        </ul>
      </div>

      <div class="section">
        <h2>2. למה אנו אוספים את המידע - מטרות השימוש</h2>
        
        <h3>מטרות חיוניות (ללא צורך בהסכמה נפרדת):</h3>
        <ul>
          <li><strong>מתן שירותי איפור:</strong> יצירת קשר, תיאום פגישות, מתן הצעות מחיר</li>
          <li><strong>תקשורת עסקית:</strong> מענה לפניות, אישור הזמנות, עדכונים על שירותים</li>
          <li><strong>אבטחת האתר:</strong> מניעת התקפות סייber ושימוש לרעה</li>
          <li><strong>עמידה בחובות חוקיים:</strong> שמירת רישומים לצרכי מס ורגולציה</li>
        </ul>

        <h3>מטרות אופציונליות (דורשות הסכמה מפורשת):</h3>
        <ul>
          <li><strong>ניתוח סטטיסטי:</strong> הבנת התנהגות משתמשים לשיפור האתר</li>
          <li><strong>שיווק מותאם אישית:</strong> הצגת תוכן ופרסומות רלבנטיים</li>
          <li><strong>שליחת עדכונים שיווקיים:</strong> מידע על שירותים חדשים והצעות מיוחדות</li>
          <li><strong>רימרקטינג:</strong> הצגת פרסומות באתרים אחרים למי שביקר באתר שלנו</li>
        </ul>
      </div>

      <div class="section">
        <h2>3. עם מי אנו משתפים את המידע</h2>
        <p>אנו עשויים לשתף מידע עם הגורמים הבאים:</p>
        
        <h3>שירותי צד שלישי שאנו משתמשים בהם:</h3>
        <ul>
          <li><strong>Google LLC:</strong>
            <ul>
              <li>Google Analytics - לניתוח תנועה באתר</li>
              <li>Google Tag Manager - לניהול תגיות מעקב</li>
              <li>Gmail - לתקשורת דוא"ל</li>
            </ul>
          </li>
          <li><strong>WhatsApp Business:</strong> לתקשורת עם לקוחות</li>
          <li><strong>ספקי אחסון ואבטחה:</strong> שירותי ענן לגיבוי ואבטחת מידע</li>
        </ul>

        <h3>מקרים נוספים של שיתוף מידע:</h3>
        <ul>
          <li><strong>דרישות חוקיות:</strong> כאשר החוק מחייב או רשויות אכיפה מבקשות</li>
          <li><strong>הגנה על זכויות:</strong> למניעת הונאה או הגנה על זכויות העסק</li>
          <li><strong>מכירת העסק:</strong> במקרה של מכירה או מיזוג עסקי (עם הודעה מוקדמת)</li>
        </ul>
      </div>

      <div class="section">
        <h2>4. משך שמירת המידע</h2>
        <p>אנו שומרים מידע לתקופות הבאות:</p>
        <ul>
          <li><strong>פרטי יצירת קשר:</strong>עד בקשת מחיקה</li>
          <li><strong>נתוני גלישה אנונימיים:</strong> 26 חודשים (ברירת מחדל של Google Analytics)</li>
          <li><strong>עוגיות:</strong> בין חודש אחד ל-2 שנים בהתאם לסוג העוגייה</li>
          <li><strong>תיעוד עסקאות:</strong> 7 שנים לצרכים חוקיים ומיסויים</li>
          <li><strong>התכתבויות:</strong> 5 שנים לצרכי שירות לקוחות</li>
          <li><strong>מידע שיווקי:</strong> עד ביטול הרשמה או בקשת מחיקה</li>
        </ul>
      </div>

      <div class="section">
        <h2>5. זכויותיך על המידע האישי</h2>
        <p>בהתאם לחוק הגנת הפרטיות, יש לך הזכויות הבאות:</p>
        
        <h3>זכות עיון:</h3>
        <p>לדעת איזה מידע אישי שמור עליך ולקבל עותק ממנו. <strong>איך לממש:</strong> שלח בקשה למייל admin@yaeltamam.com עם פרטי זיהוי.</p>
        
        <h3>זכות תיקון:</h3>
        <p>לתקן מידע שגוי או לא מדויק. <strong>איך לממש:</strong> פנה אלינו בטלפון 053-7002122 או במייל עם הפרטים הנכונים.</p>
        
        <h3>זכות מחיקה ("הזכות להישכח"):</h3>
        <p>למחוק את המידע שלך מהמערכות שלנו. <strong>איך לממש:</strong> שלח בקשת מחיקה למייל admin@yaeltamam.com. נמחק את המידע תוך 30 יום.</p>
        
        <h3>זכות הגבלת עיבוד:</h3>
        <p>להגביל את השימוש במידע שלך למטרות מסוימות בלבד. <strong>איך לממש:</strong> פרט את ההגבלות הרצויות בפנייה אלינו.</p>
        
        <h3>זכות התנגדות:</h3>
        <p>להתנגד לעיבוד מידע למטרות שיווק או פרופיילינג. <strong>איך לממש:</strong> לחץ על "בטל הרשמה" בהודעות שיווק או פנה אלינו ישירות.</p>
        
        <h3>זכות משיכת הסכמה:</h3>
        <p>למשוך הסכמה שנתת לעיבוד מידע. <strong>איך לממש:</strong> שנה את הגדרות העוגיות באתר או פנה אלינו.</p>
        
        <h3>זכות ניידות נתונים:</h3>
        <p>לקבל את המידע שלך בפורמט מובנה וניתן להעברה. <strong>איך לממש:</strong> בקש זאת במייל ונשלח לך קובץ עם המידע.</p>
        
        <p><strong>זמני מענה:</strong> נענה לבקשות תוך 30 יום. במקרים מורכבים ניתן להאריך ל-60 יום עם הודעה מוקדמת.</p>
      </div>

      <div class="section">
        <h2>6. אמצעי אבטחת המידע</h2>
        <p>אנו נוקטים באמצעי האבטחה הבאים להגנה על המידע שלך:</p>
        <ul>
          <li><strong>הצפנת תקשורת:</strong> כל התקשורת מוצפנת ב-TLS/SSL</li>
          <li><strong>הגבלות גישה:</strong> רק עובדים מורשים יכולים לגשת למידע אישי</li>
          <li><strong>עדכוני אבטחה:</strong> מערכות מתעדכנות באופן קבוע</li>
          <li><strong>גיבויים מוצפנים:</strong> גיבוי המידע מוצפן ומאובטח</li>
          <li><strong>ניטור אבטחה:</strong> מעקב אחר פעילות חשודה</li>
          <li><strong>הדרכת עובדים:</strong> הדרכה קבועה בנושאי אבטחת מידע</li>
        </ul>
        <p><strong>חשוב לדעת:</strong> למרות המאמצים, אין אבטחה מוחלטת ברשת האינטרנט. אנו ממליצים להיזהר במידע שאתה משתף באינטרנט.</p>
      </div>

      <div class="section">
        <h2>7. העברת מידע לחוץ לארץ</h2>
        <p>חלק מהשירותים שאנו משתמשים בהם (כמו Google Analytics) עשויים להעביר מידע לשרתים מחוץ לישראל, בעיקר לארצות הברית ואירופה. העברות אלו מתבצעות תחת הגנות משפטיות מתאימות.</p>
      </div>

      <div class="section">
        <h2>8. שינויים במדיניות הפרטיות</h2>
        <p>אנו עשויים לעדכן מדיניות זו מעת לעת. שינויים מהותיים יפורסמו באתר עם הודעה של 30 יום מראש. המשך השימוש באתר לאחר השינויים מהווה הסכמה למדיניות המעודכנת.</p>
      </div>

      <div class="section">
        <h2>9. יצירת קשר ותלונות</h2>
        <p>לשאלות, בקשות או תלונות בנושא פרטיות:</p>
        <ul>
          <li><strong>אחראי הגנת פרטיות:</strong> ליאור תמם</li>
          <li><strong>טלפון:</strong> <a href="tel:+972537002122">053-7002122</a></li>
          <li><strong>דוא"ל:</strong> <a href="mailto:admin@yaeltamam.com">admin@yaeltamam.com</a></li>
          <li><strong>כתובת:</strong> אפרסמון 5, אשדוד</li>
        </ul>
        
        <p><strong>תלונה לרשות הגנת הפרטיות:</strong> אם אינך מרוצה מהטיפול בפנייתך, ניתן להגיש תלונה לרשות הגנת הפרטיות דרך האתר <a href="https://www.gov.il/he/departments/the_privacy_protection_authority" target="_blank">gov.il</a> או בטלפון *3455.</p>
      </div>

      <div class="section">
        <h2>10. מידע נוסף</h2>
        <p>מדיניות זו כתובה בשפה ברורה ומובנת. אם יש לך שאלות או אם משהו לא ברור, אנא פנה אלינו לקבלת הבהרות נוספות.</p>        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy-policy {
  padding: 40px 20px;
  background: #f8f9fa;
  min-height: 80vh;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

h1 {
  color: #2c3e50;
  margin-bottom: 30px;
  text-align: center;
  border-bottom: 3px solid #3498db;
  padding-bottom: 15px;
}

h2 {
  color: #34495e;
  margin: 30px 0 15px 0;
  padding: 10px 0;
  border-bottom: 1px solid #ecf0f1;
}

.section {
  margin-bottom: 25px;
}

p {
  line-height: 1.6;
  margin-bottom: 15px;
  color: #2c3e50;
}

ul {
  margin: 15px 0;
  padding-right: 20px;
}

li {
  margin: 8px 0;
  line-height: 1.5;
}

a {
  color: #3498db;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .privacy-policy {
    padding: 20px 10px;
  }
  
  .container {
    padding: 25px 20px;
  }
  
  h1 {
    font-size: 24px;
  }
  
  h2 {
    font-size: 20px;
  }
}
</style>